export default "__VITE_ASSET__Bqyrh937__"